export const en = {
    'add-group': 'Add a group',
    'combinations-count': {
        one: '{count} keyword will be created and added to the list.',
        some: '{count} keywords will be created and added to the list.',
        many: '{count} keywords will be created and added to the list.',
        none: '{count} keywords will be created and added to the list.'
    }
};
